import type {DateValue} from '@ark-ui/react'
import {parseDate} from '@chakra-ui/react'

// A batch expiry is a calendar day (CY-371): the picked day is saved as its UTC midnight, the value Zero reads back.
export function getStartOfUtcDay(date: DateValue): number {
  return date.toDate('UTC').getTime()
}

/** The calendar day of a batch expiry as a local Date, for day differences in the user's calendar. */
export function utcDayAsLocalDate(timestamp: number): Date {
  const date = new Date(timestamp)
  return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate())
}

// The UTC calendar day of a timestamp, so an end-of-day UTC value is not read as the next local day.
export function getUtcDay(timestamp: number): DateValue {
  return parseDate(new Date(timestamp).toISOString().slice(0, 10))
}
